// extracted by mini-css-extract-plugin
export default {"host":"MediaLogoItem_host__aoDn8"};